import { Box, Skeleton } from '@mui/material';
import type { FC } from 'react';

import { NewFeatureHeader, Page } from '@web/components';

const previewRows = 8;

// A static stand-in under the blur: the real grid arrives with later stories,
// and the preview only needs enough shape to read as a page.
export const ObfuscatedPlanningPage: FC = () => (
  <Page title='Planning'>
    <NewFeatureHeader
      featureName='Planning'
      promoLines={[
        'Build your annual budget bottom-up by customer and product, lock it when it is',
        'approved, and revise forecasts month by month against what actually shipped, all',
        'in one place instead of dozens of linked spreadsheets.',
      ]}
      sx={{ marginBottom: '3.75rem' }}
    />
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {Array.from({ length: previewRows }, (_, i) => (
          <Skeleton key={i} variant='rectangular' height={48} animation={false} />
        ))}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 10,
          pointerEvents: 'all', // blocks interaction
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 300px)',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 300px)',
        }}
      />
    </Box>
  </Page>
);
